import { useRef } from 'react';
export var useDebouncer = function useDebouncer() {
  var debounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 320;
  var debouncer = useRef(undefined);
  var clearDebounce = function clearDebounce() {
    clearTimeout(debouncer.current);
  };
  var runWithDebounce = function runWithDebounce(cb) {
    clearDebounce();
    debouncer.current = setTimeout(function () {
      cb();
    }, debounce);
  };
  return [runWithDebounce, clearDebounce];
};